module.exports = __webpack_public_path__ + "img/girl-body-front.d94c006c.png";